import React from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import "../sass/pages/EventsPage.scss";
import withSystemState, {InjectedSystemStateProps} from "../components/hocs/WithSystemState";
import withApiHandler, {ErrorHandler, InjectedApiHandlerProps} from "../components/hocs/WithApiHandler";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from 'react-bootstrap/Dropdown';
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import NavBar from "../components/navigation/NavBar";
import Table from "react-bootstrap/Table";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Button from "react-bootstrap/Button";
import {FaFacebookF, FaInstagram, FaList, FaRegSquare, FaStar} from "react-icons/fa";
import Badge from "react-bootstrap/Badge";
import * as _ from "lodash";
import ReactPaginate from 'react-paginate';
import {AiOutlineSortAscending, AiOutlineSortDescending} from "react-icons/ai";
import * as firebase from "firebase/app";
import "firebase/firestore";
import ReactGA from "react-ga";
import BILogo from "../images/BILogo.png";

export type EventsPageProps = RouteComponentProps & InjectedSystemStateProps & InjectedApiHandlerProps;

interface EventsPageState {
    loading: boolean;
    page: number;
    displayType: string;
    events: any[];
    pagedEvents: any[][];
    pagedEntriesIndex: number;
    sortBy: string;
    sortByLabel: string;
    sortDirection: string;
    pageLabel: string;
}

interface MasterEvent {
    link: string;
    staffPick: boolean;
    location: string;
    name: string;
    date: string;
    rsvpStatus: string;
}

interface WWWEvent {
    link: string;
    staffPick: boolean;
    name: string;
    startTime: string;
    endTime: string;
    location: string;
    freeBooze: string;
    freeFood: string;
    notes: string
}

const pageTitles = ["Master","Friday, March 13","Saturday, March 14","Sunday, March 15","Monday, March 16","Tuesday, March 17","Wednesday, March 18","Thursday, March 19","Friday, March 20","Saturday, March 21","Sunday, March 22"];

class EventsPage extends React.Component<EventsPageProps, EventsPageState> {

    state = {
        loading: false,
        page: 0,
        displayType: "table",
        events: [],
        pagedEvents: [[]],
        pagedEntriesIndex:0,
        sortBy: "name",
        sortByLabel: "Sort By",
        sortDirection: "asc",
        pageLabel: "Select A List"
    };

    componentDidMount(): void {

    }

    loadEvents = (page: number) => {
        this.setState({
            pageLabel: pageTitles[page]
        },()=>{
            ReactGA.pageview("/events/"+pageTitles[page]);
            var docRef = firebase.firestore().collection("eventSheets").doc("Sheet"+page);
            docRef.get().then((data)=>{
                let content = data.data() as any;
                let events = content.events;
                let pagedEvents = _.chunk(events,20);
                this.setState({page: page, events: events, pagedEvents:pagedEvents, pagedEntriesIndex:0,sortBy: "name",sortByLabel: "Sort By",sortDirection: "asc"});
            });
        });
    };

    sortBy = (sortBy: string, sortByLabel: string) =>{
        let events = [...this.state.events];
        let monthIntFunc = this.getMonthInt;
        let sorted = _.sortBy(events,[function(o) {
            let col = o[sortBy] as string;
            if(sortBy=="date"){
                let drange = col.match(/(.+) (\d+)-\d+/i);
                if(drange!=null){
                    let day = drange[2].padStart(2,"0");
                    let month = (monthIntFunc(drange[1])+"").padStart(2,"0");
                    return new Date('1970-'+month+'-'+day+'T00:00:00Z');
                }else{
                    let d = col.match(/(.+) (\d+).+/i);
                    if(d!=null) {
                        let day = d[2].padStart(2,"0");
                        let month = (monthIntFunc(d[1])+"").padStart(2,"0");
                        return new Date('1970-'+month+'-'+day+'T00:00:00Z');
                    }else{
                        return new Date('1970-01-01T00:00:00Z');
                    }
                }
            }else if(sortBy=="startTime" || sortBy=="endTime"){
                let t = col.match(/(\d+)((:)(\d{2}))*(pm|am)/i);
                if(t!=null) {
                    let hour = "00";
                    let minute = "00";
                    if(t[2]!=undefined){
                        let nhour = Number(t[1]);
                        if(nhour==12){
                            if(t[5].toLowerCase()==="am") {
                                nhour = 0;
                            }
                        }else{
                            if(t[5].toLowerCase()==="pm"){
                                nhour = nhour+12;
                            }
                        }
                        hour = (nhour+"").padStart(2,"0");
                        minute = t[4].padStart(2,"0");
                    }else{
                        let nhour = Number(t[1]);
                        if(nhour==12){
                            if(t[5].toLowerCase()==="am") {
                                nhour = 0;
                            }
                        }else{
                            if(t[5].toLowerCase()==="pm"){
                                nhour = nhour+12;
                            }
                        }
                        hour = (nhour+"").padStart(2,"0");
                    }
                    return new Date('1970-01-01T'+hour+':'+minute+':00Z');
                }else{
                    return new Date('1969-01-01T00:00:00Z');
                }
            } else {
                return col.toLowerCase();
            }
        },function(o) { let col = o["name"] as string; return col.toLowerCase() }]);
        let pagedEvents = _.chunk(sorted,20);
        this.setState({events: sorted, pagedEvents:pagedEvents, pagedEntriesIndex:0, sortBy:sortBy, sortByLabel: sortByLabel, sortDirection: "asc"});
    };

    getMonthInt = (month:string) =>{
        let m = month.toLowerCase();
        switch (m) {
            case "january":
                return 1;
            case "february":
                return 2;
            case "march":
                return 3;
        }
    };

    reverse = () =>{
        let events = [...this.state.events];
        let reversed = _.reverse(events);
        let pagedEvents = _.chunk(reversed,20);
        let direction = this.state.sortDirection==="asc"?"desc":"asc";
        this.setState({events: reversed, pagedEvents:pagedEvents, pagedEntriesIndex:0, sortDirection: direction});
    };

    getSortByDropDown = () =>{
        if(this.state.page==0){
            return(
                <div className={"sortby-picker"}>
                    <ButtonGroup>
                        <DropdownButton id="dropdown-sort-by" as={ButtonGroup} title={this.state.sortByLabel} variant="light">
                            <Dropdown.Item href="#!" onClick={() => this.sortBy("name","Name")}>Name</Dropdown.Item>
                            <Dropdown.Item href="#!" onClick={() => this.sortBy("staffPick","Staff Pick")}>Staff Pick</Dropdown.Item>
                            <Dropdown.Item href="#!" onClick={() => this.sortBy("location","Venue")}>Venue</Dropdown.Item>
                            <Dropdown.Item href="#!" onClick={() => this.sortBy("date","Date")}>Date</Dropdown.Item>
                            <Dropdown.Item href="#!" onClick={() => this.sortBy("rsvpStatus","RSVP Status")}>RSVP Status</Dropdown.Item>
                        </DropdownButton>
                        <Button className="sortby-button" size={"sm"} variant="light" onClick={()=>this.reverse()}>{this.state.sortDirection==="desc"?<AiOutlineSortAscending/>:<AiOutlineSortDescending/>}</Button>
                    </ButtonGroup>
                </div>
            );
        }else{
            return(
                <div className={"sortby-picker"}>
                    <ButtonGroup>
                        <DropdownButton id="dropdown-sort-by" as={ButtonGroup} title={this.state.sortByLabel} variant="light">
                            <Dropdown.Item href="#!" onClick={() => this.sortBy("name","Name")}>Name</Dropdown.Item>
                            <Dropdown.Item href="#!" onClick={() => this.sortBy("staffPick","Staff Pick")}>Staff Pick</Dropdown.Item>
                            <Dropdown.Item href="#!" onClick={() => this.sortBy("location","Venue")}>Venue</Dropdown.Item>
                            <Dropdown.Item href="#!" onClick={() => this.sortBy("startTime","Start Time")}>Start Time</Dropdown.Item>
                            <Dropdown.Item href="#!" onClick={() => this.sortBy("endTime","End Time")}>End Time</Dropdown.Item>
                            <Dropdown.Item href="#!" onClick={() => this.sortBy("freeBooze","Free Booze?")}>Free Booze?</Dropdown.Item>
                            <Dropdown.Item href="#!" onClick={() => this.sortBy("freeFood","Free Food?")}>Free Food?</Dropdown.Item>
                            <Dropdown.Item href="#!" onClick={() => this.sortBy("notes","Notes")}>Notes</Dropdown.Item>
                        </DropdownButton>
                        <Button className="sortby-button" size={"sm"} variant="light" onClick={()=>this.reverse()}>{this.state.sortDirection==="desc"?<AiOutlineSortAscending/>:<AiOutlineSortDescending/>}</Button>
                    </ButtonGroup>
                </div>
            );
        }
    };

    convertToMasterEvents = (chunks:any[]) =>{
        let events = [] as MasterEvent[];
        chunks.map((chunk:any[])=>{
            let event = {
                name: chunk[0].content.$t,
                staffPick: chunk[1].content.$t,
                date: chunk[2].content.$t,
                location: chunk[3].content.$t,
                rsvpStatus: chunk[4].content.$t,
                link: chunk[5].gs$cell.inputValue,
            } as MasterEvent;
            events.push(event);
        });
        return events;
    };

    convertToEvents = (chunks:any[]) =>{
        let events = [] as WWWEvent[];
        chunks.map((chunk:any[])=>{
            let event = {
                name: chunk[0].content.$t,
                staffPick: chunk[1].content.$t,
                startTime: chunk[2].content.$t,
                endTime: chunk[3].content.$t,
                location: chunk[4].content.$t,
                freeBooze: chunk[5].content.$t,
                freeFood: chunk[6].content.$t,
                notes: chunk[7].content.$t,
                link: chunk[8].gs$cell.inputValue,
            } as WWWEvent;
            events.push(event);
        });
        return events;
    };

    renderEvents = () => {
        if(this.state.events && this.state.events.length>0) {
            if(this.state.displayType==="table"){
                return this.renderTableView();
            }else if(this.state.displayType==="cards"){
                return this.renderCardView();
            }
        }
        return (<div className={"empty-events"}/>)
    };

    renderTableView = () =>{
        if(this.state.page===0) {
            return(
                <div className={"table-container"}>
                    <Table striped bordered hover variant="dark">
                        <thead>
                        <tr>
                            <th>Staff Pick</th>
                            <th>Event</th>
                            <th>Date</th>
                            <th>Venue</th>
                            <th>RSVP Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.pagedEvents[this.state.pagedEntriesIndex].map((entry: MasterEvent,index:number) => {
                            return (
                                <tr className={"divider"} key={"event-"+index}>
                                    <td className={"staff-pick"}>{this.getStaffPick(entry.staffPick)}</td>
                                    <td className={"title"}><a target="_blank" href={this.getLink(entry.link)}>{entry.name}</a></td>
                                    <td>{entry.date}</td>
                                    <td>{this.getLocationLink(entry.location)}</td>
                                    <td>{entry.rsvpStatus}</td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </Table>
                </div>
            );
        }else{
            return(
                <div className={"table-container"}>
                    <Table striped bordered hover variant="dark">
                        <thead>
                        <tr>
                            <th>Staff Pick</th>
                            <th>Event</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Location</th>
                            <th>Free Booze?</th>
                            <th>Free Food?</th>
                            <th>Notes</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.pagedEvents[this.state.pagedEntriesIndex].map((entry: WWWEvent,index:number) => {
                            return (
                                <tr className={"divider"} key={"event-"+index}>
                                    <td className={"staff-pick"}>{this.getStaffPick(entry.staffPick)}</td>
                                    <td className={"title"}><a target="_blank" href={this.getLink(entry.link)}>{entry.name}</a></td>
                                    <td>{entry.startTime}</td>
                                    <td>{entry.endTime}</td>
                                    <td >{this.getLocationLink(entry.location)}</td>
                                    <td>{entry.freeBooze}</td>
                                    <td>{entry.freeFood}</td>
                                    <td>{entry.notes}</td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </Table>
                </div>
            );
        }
    };

    getLink = (link:string) =>{

        if(link && link.length>0){
            return link;
        }
        return undefined;

    };

    getStaffPick = (content:boolean) =>{
        if(content){
            return(
                <Badge pill variant="primary"><FaStar/></Badge>
            );
        }
        return null;
    };

    getLocationLink = (location:string) =>{
        if(location && location.length>0){
            let text = location.toLowerCase();
            if(text.includes("secret") || text.includes("tba")){
                return <span>{text}</span>
            }else{
                return <a className={"link"} href={"http://maps.google.com/maps?q="+text+",+Austin,+Texas"} target="_blank">{text}</a>
            }
        }
    };

    renderCardView = () =>{
        if(this.state.page===0) {
            return (
                <Container className={"events cards"}>
                    <Row>
                        {this.state.pagedEvents[this.state.pagedEntriesIndex].map((entry: MasterEvent,index:number) => {
                            return (
                                <Col xs={12} md={4} lg={3} className={"divider"} key={"event-"+index}>
                                    <div className={"event"}>
                                        <div className={"staff-pick"}>
                                            {this.getStaffPick(entry.staffPick)}
                                        </div>
                                        <div className={"title"}>
                                            <a target="_blank" href={this.getLink(entry.link)}>{entry.name}</a>
                                        </div>
                                        <div className={"data"}>
                                            <span className={"bold"}> Date:</span> {entry.date}
                                        </div>
                                        <div className={"data"}>
                                            <span className={"bold"}>Venue:</span> {this.getLocationLink(entry.location)}
                                        </div>
                                        <div className={"data"}>
                                            <span className={"bold"}>RSVP Status:</span> {entry.rsvpStatus}
                                        </div>
                                    </div>
                                </Col>
                            );
                        })}
                    </Row>
                </Container>
            );
        }else{
            return (
                <Container className={"events cards"}>
                    <Row>
                        {this.state.pagedEvents[this.state.pagedEntriesIndex].map((entry: WWWEvent,index:number) => {
                            return (
                                <Col xs={12} md={6} lg={4} className={"divider"} key={"event-"+index}>
                                    <div className={"event"}>
                                        <div className={"staff-pick"}>
                                            {this.getStaffPick(entry.staffPick)}
                                        </div>
                                        <div className={"title"}>
                                            <a target="_blank" href={this.getLink(entry.link)}>{entry.name}</a>
                                        </div>
                                        <div className={"data"}>
                                            <span className={"bold"}>Start:</span> {entry.startTime}
                                        </div>
                                        <div className={"data"}>
                                            <span className={"bold"}>End:</span> {entry.endTime}
                                        </div>
                                        <div className={"data"}>
                                            <span className={"bold"}>Location:</span> {this.getLocationLink(entry.location)}
                                        </div>
                                        <div className={"data"}>
                                            <span className={"bold"}>Free Booze?</span> {entry.freeBooze}
                                        </div>
                                        <div className={"data"}>
                                            <span className={"bold"}>Free Food?</span> {entry.freeFood}
                                        </div>
                                        <div className={"data notes"}>
                                            <span className={"bold"}>Notes:</span> {entry.notes}
                                        </div>
                                    </div>
                                </Col>
                            );
                        })}
                    </Row>
                </Container>
            );
        }
    };

    render() {
        return (
            <>
                <NavBar/>
                {getSocialLinks()}
                <div className={"action-nav"}>
                    <DropdownButton id="dropdown-basic-button" title={this.state.pageLabel} className={"list-picker"} variant="light">
                        <Dropdown.Item href="#!" onClick={() => this.loadEvents(0)}>{pageTitles[0]}</Dropdown.Item>
                        <Dropdown.Item href="#!" onClick={() => this.loadEvents(1)}>{pageTitles[1]}</Dropdown.Item>
                        <Dropdown.Item href="#!" onClick={() => this.loadEvents(2)}>{pageTitles[2]}</Dropdown.Item>
                        <Dropdown.Item href="#!" onClick={() => this.loadEvents(3)}>{pageTitles[3]}</Dropdown.Item>
                        <Dropdown.Item href="#!" onClick={() => this.loadEvents(4)}>{pageTitles[4]}</Dropdown.Item>
                        <Dropdown.Item href="#!" onClick={() => this.loadEvents(5)}>{pageTitles[5]}</Dropdown.Item>
                        <Dropdown.Item href="#!" onClick={() => this.loadEvents(6)}>{pageTitles[6]}</Dropdown.Item>
                        <Dropdown.Item href="#!" onClick={() => this.loadEvents(7)}>{pageTitles[7]}</Dropdown.Item>
                        <Dropdown.Item href="#!" onClick={() => this.loadEvents(8)}>{pageTitles[8]}</Dropdown.Item>
                        <Dropdown.Item href="#!" onClick={() => this.loadEvents(9)}>{pageTitles[9]}</Dropdown.Item>
                        <Dropdown.Item href="#!" onClick={() => this.loadEvents(10)}>{pageTitles[10]}</Dropdown.Item>
                    </DropdownButton>
                </div>
                <div className={"display-group"}>
                    <ButtonGroup aria-label="Display Type">
                        <Button variant="light" active={this.state.displayType==="table"} onClick={()=>this.setState({displayType:"table"})}><FaList/></Button>
                        <Button variant="light" active={this.state.displayType==="cards"} onClick={()=>this.setState({displayType:"cards"})}><FaRegSquare/></Button>
                    </ButtonGroup>
                </div>
                {this.state.events.length<=0?null:this.getSortByDropDown()}
                {this.state.events.length<=0?null:<div className={"pagination-container"}><ReactPaginate forcePage={this.state.pagedEntriesIndex} onPageChange={(selectedItem: { selected: number })=>this.setState({pagedEntriesIndex:selectedItem.selected})} previousLabel={"<"} nextLabel={">"} breakClassName={"page-item"} breakLinkClassName={"page-link"} activeClassName={"active"} containerClassName={"pagination"} previousLinkClassName={"page-link"} previousClassName={"page-item"} nextClassName={"page-item"} pageLinkClassName={"page-link"} nextLinkClassName={"page-link"} pageClassName={"page-item"} pageCount={this.state.pagedEvents.length} pageRangeDisplayed={3} marginPagesDisplayed={2}/></div>}
                {this.renderEvents()}
                <div className={"poweredby"}>
                    <div className={"text"}>
                        Powered by
                    </div>
                    <div className={"logo"}>
                        <a href={"https://bohemian.cc"}><img src={BILogo}/></a>
                    </div>
                </div>
            </>
        );
    }
}

export function getSocialLinks(){
    return(
        <div className={"social-info"}>
            <div className={"badges"}>
                <a href={"https://www.facebook.com/whenwherewhataustin/"} target="_blank"><Badge pill variant="primary"><FaFacebookF/></Badge></a>
                <a href={"https://www.instagram.com/whenwherewhataustin/"} target="_blank"><Badge pill variant="primary"><FaInstagram/></Badge></a>
            </div>
        </div>
    );
}

export default withSystemState(withRouter(withApiHandler(EventsPage, ErrorHandler.TOAST)));